// @flow
import {translate} from 'sulu-admin-bundle/utils';
import {AbstractFormToolbarAction} from 'sulu-admin-bundle/views';

/**
 * Downloads one of the Excel documents (invoice, estimate, ...) for the address of the current form.
 */
export default class ExportAddressDocumentToolbarAction extends AbstractFormToolbarAction {
    getToolbarItemConfig() {
        const {type, label} = this.options;
        const {id, dirty} = this.resourceFormStore;

        if (typeof type !== 'string' || typeof label !== 'string') {
            throw new Error('The "type" and "label" options must be strings!');
        }

        return {
            type: 'button',
            label: translate(label),
            // Unsaved changes would not be in the document, so save first.
            disabled: !id || dirty,
            onClick: () => {
                window.location.assign('/admin/api/addresses/' + encodeURIComponent(String(id)) + '/export/' + type);
            },
        };
    }
}
